
export const floatTo16BitPCM = (output, offset, input) => {
  for (let i = 0; i < input.length; i++, offset += 2) {
    const s = Math.max(-1, Math.min(1, input[i]));
    output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
  }
};

export const writeString = (view, offset, string) => {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i));
  }
};

export const encodeWAV = (samples, sampleRate, numChannels) => {
  const buffer = new ArrayBuffer(44 + samples.length * 2);
  const view = new DataView(buffer);
  
  writeString(view, 0, 'RIFF');
  view.setUint32(4, 36 + samples.length * 2, true);
  writeString(view, 8, 'WAVE');
  writeString(view, 12, 'fmt ');
  view.setUint32(16, 16, true); 
  view.setUint16(20, 1, true); 
  view.setUint16(22, numChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * numChannels * 2, true); 
  view.setUint16(32, numChannels * 2, true); 
  view.setUint16(34, 16, true); 
  writeString(view, 36, 'data');
  view.setUint32(40, samples.length * 2, true);
  
  floatTo16BitPCM(view, 44, samples);
  
  return buffer;
};

export const playUserRecordingWithVoiceChanger = async (audioUrl, onEnded) => {
  if (!audioUrl) {
    if (onEnded) onEnded();
    return;
  }

  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const response = await fetch(audioUrl);
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    
    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;
    
    source.playbackRate.value = 1.25;
    
    source.connect(audioContext.destination);
    
    source.onended = () => {
      setTimeout(() => {
        if (audioContext.state !== 'closed') {
          audioContext.close().catch(() => {});
        }
      }, 100);
      if (onEnded) onEnded();
    };
    
    source.onerror = () => {
      if (audioContext.state !== 'closed') {
        audioContext.close().catch(() => {});
      }
      if (onEnded) onEnded();
    };
    
    source.start(0);
  } catch (error) {
    console.error('Error playing user recording with voice changer:', error);
    try {
      const audio = new Audio(audioUrl);
      audio.onended = () => {
        if (onEnded) onEnded();
      };
      audio.onerror = () => {
        if (onEnded) onEnded();
      };
      audio.play().catch(() => {
        if (onEnded) onEnded();
      });
    } catch (fallbackError) {
      console.error('Error in fallback audio playback:', fallbackError);
      if (onEnded) onEnded();
    }
  }
};

